import { AxiosError } from "axios";

/** Mensaje de un error de la API: usa el `detail` que devuelve DRF, si viene. */
export function mensajeDeError(error: unknown, fallback: string): string {
  const detail = (error as AxiosError<{ detail?: string }>)?.response?.data?.detail;
  return typeof detail === "string" && detail ? detail : fallback;
}
